import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { DispatcherV2Request, DispatcherV2SingleResponse, GroupMode } from '@bringg/types';

export const loadRouteGroups = async (routeIds: number[], teamId: number): Promise<DispatcherV2SingleResponse> => {
	const request: DispatcherV2Request = {
		query_requests: [
			{
				entity_type: 'task',
				grouping: GroupMode.Route,
				page: { limit: 1000 },
				collapsed_groups: [],
				filters: { selectedTeams: [teamId], selectedRuns: routeIds },
				sorting: { key: 'id' }
			}
		]
	};

	try {
		const response = await getRootEnv().dashboardSdk.sdk.v2.tasksExplorer.getAll(request);
		return response.query_responses[0];
	} catch (e) {
		console.error('error in loading route tasks');
	}
};
